import {h} from 'preact';
import EmailList from './email-list';

export function AddAssociatedUsersAlreadyExist({feedback, usersNum, key}) {
	const instructions = 'To change the end date of an association, remove the association first, then re-add the user.';
	let message = `${feedback} is already associated. ${instructions}`;

	if (usersNum > 1) {
		message = <EmailList key={key} feedback={feedback}
							 text={`${usersNum} email addresses are already associated. ${instructions} Email addresses already associated:`}/>;
	}

	return (
		<div className="eds-c-status-message eds-c-status-message--warning">
			<div className="eds-c-status-message__content-icon">
				<svg  aria-hidden="true" width="16" height="16"
					 className="eds-c-status-message__icon">
					<use href="/static/img/svg-sprite.svg#warning"/>
				</svg>
			</div>
			<div className="eds-c-status-message__text">
						<span data-testid="duplicate-email">
								{message}
						</span>
			</div>
		</div>
	)
		;
}

export default AddAssociatedUsersAlreadyExist;
